import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import PaymentMethod from './paymentMethod'
import UseSavedPaymentData from './UseSavedPaymentData'

const Container = styled.div`
  display: flex;
  flex-direction: column;


`

@inject(all => ({
  payment: all.store.payment,
  defaultPaymentMethod: all.store.payment.defaultPaymentMethod,
  hasDefaultPaymentMethod: all.store.payment.hasDefaultPaymentMethod,
  isAddingNewPaymentMethod: all.store.payment.isAddingNewPaymentMethod,
  toggleAddPaymentMethod: all.store.payment.toggleAddPaymentMethod
}))
@observer
class DefaultPaymentMethod extends Component {
  render() {
    const {
      defaultPaymentMethod,
      hasDefaultPaymentMethod,
      isAddingNewPaymentMethod,
      toggleAddPaymentMethod
    } = this.props
    if (!hasDefaultPaymentMethod) return null

    let paymentMessage
    switch (defaultPaymentMethod.paymentType) {
      case 'Card':
        paymentMessage = `Pay with saved ${
          defaultPaymentMethod.cardType
        } ending in ${defaultPaymentMethod.last4}`
        break
      case 'PayPal':
        paymentMessage = `Pay with saved PayPal account: ${
          defaultPaymentMethod.email
        }.`
        break
      default:
        paymentMessage = `Pay with your saved payment method`
    }

    return (
      <Container isAddingNewPaymentMethod={isAddingNewPaymentMethod}>
        {!isAddingNewPaymentMethod ? (
          <PaymentMethod {...defaultPaymentMethod} addHandler={toggleAddPaymentMethod} />
        ) : (
          <UseSavedPaymentData onClick={toggleAddPaymentMethod}>{paymentMessage}</UseSavedPaymentData>
        )}
      </Container>
    )
  }
}

export default DefaultPaymentMethod
